import Header from "./components/Header";
import Intro from "./components/Intro";
import Skills from "./components/Skills";
import Projetos from "./components/Projetos";
import Certificado from "./components/Certificado";
import Footer from "./components/Footer";


function App() {
  return (
    <div>
      <Header/>
      <Intro/>
      <Skills/>
      <Projetos/>
      <Certificado/>
      <Footer/>
    </div>
  );
}

export default App;
